import type { ReactNode } from "react";
import { createPortal } from "react-dom";
import { useDataGridContext } from "../DataGridContext";
import styles from "./states.module.scss";

interface StateMessageProps {
    role: "status" | "alert";
    children: ReactNode;
}

/**
 * The empty or error message, in the grid's message layer under the header
 * (after the grid in reading and tab order), or in place without a grid.
 */
export const StateMessage = ({
    role,
    children,
}: Readonly<StateMessageProps>) => {
    const { messageLayer } = useDataGridContext();
    const message = (
        <div className={styles.message} role={role}>
            {children}
        </div>
    );
    return messageLayer ? createPortal(message, messageLayer) : message;
};
